'use strict';

DoohApps
    .factory('LanguageData', ['restApi', function (restApi) {
        var controllerName = 'Language/';

        return {
            getLanguageList: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetLanguageList');
            },
            getLanguagesForCompany: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetLanguagesForCompany');
            },
            addRemoveLanguagesToFromCompany: function (successCallback, languages) {
                restApi.PostApiMethod(successCallback, controllerName + 'AddRemoveLanguagesToFromCompany', languages);
            }
        }
    }]);
